module.exports = __webpack_public_path__ + "static/media/logo.51a62b22.png";